import React, { Component } from 'react';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/lab/Alert';

let openSnackbarFn=()=>{};
class MuiSnackbarCustom extends Component  {
  
  state = {
    open: false,
    message: '',
  };

  handleClose=(e,result) => {
    if(result==='clickaway')
       return
    this.setState({
        open: false,
        message: '',
      });
  }

  componentDidMount(){
    openSnackbarFn = this.openSnackbar;
  }

  openSnackbar = (message,severity) => {
   
    this.setState({ 
    open: true, 
    message:message,
    severity:severity});

  }
  
  render()
  {
    const { open,message,severity } = this.state;  
    
    return (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          data-testid="snackbar"
          open={open}
          onClose={(e,result)=>this.handleClose(e,result)}
          autoHideDuration={4000}
        >
          <MuiAlert data-testid='mui-alert-info' onClose={this.handleClose} severity={severity} elevation={6} variant="filled">
              {message}
          </MuiAlert>
        
        </Snackbar>
      )
  ;}

}

export function openSuccessSnackbar(message) {
    if(message!== undefined && message!=='')
    openSnackbarFn(message ,"success");
} 
export function openErrorSnackbar( message) {
    if(message!== undefined && message!=='')
    openSnackbarFn(message ,"error");
} 
export default MuiSnackbarCustom; 
